import { useSearchParams } from 'react-router-dom'
import AutoClaims from '../policies/auto/claims';
import NonAutoClaims from '../policies/non-auto/claims';

interface PoliciesProps {
    defaultType?: 'motor' | 'non-motor';
}

const Claims = ({ defaultType = 'motor' }: PoliciesProps) => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type');

    return (
        <>
            {type &&
                <div>
                    {type === 'motor' ? <AutoClaims /> : <NonAutoClaims />}
                </div>
            }
        </>
    )
}

export default Claims